@if (displayStepper) {
  <div class="generic-stepper__container content steps"
    [ngClass]="'layout-align-'+layoutAlign+ ' layout-'+layout"
    fxFlex
    [fxLayout]="layout"
    [fxLayoutAlign]="layoutAlign">
    @if (options.isListFormatStepper) {
      <div class="generic-stepper__left-toolbar">
        <ng-content select="[toolbar-before-stepper]"></ng-content>
      </div>
      <button class="generic-stepper__previous-button previous"
        [ngStyle]="{'visibility' : isPreviousVisible()?'visible':'hidden'}"
        [disabled]="isLocked"
        (click)="previous()"
        [attr.aria-label]="'generic.previous' | translate"
        [matTooltip]="'generic.previous' | translate">
        <mat-icon svgIcon="arrow_left"></mat-icon>
      </button>
      @if (options.steps.length > 1) {
        <mat-form-field
          class="generic-stepper__select-field"
          appearance="fill">
          <mat-select panelClass="generic-stepper__select-panel"
            [(value)]="selectedStep"
            (selectionChange)="clickOnElem($event.value)"
            [disabled]="isLocked">
            @for (step of options.steps; track step) {
              <mat-option
                [value]="step">
                {{getLabelToDisplay(step)}} / {{options.steps.length}} - {{stepTitle(step)}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <button class="generic-stepper__next-button next"
        [ngStyle]="{'visibility' : isNextVisible()?'visible':'hidden'}"
        [disabled]="isLocked || isLockedNext"
        (click)="next()"
        [attr.aria-label]="'generic.next' | translate"
        [matTooltip]="'generic.next' | translate">
        <mat-icon svgIcon="arrow_right"></mat-icon>
      </button>
      <div class="generic-stepper__right-toolbar">
        <ng-content select="[toolbar-after-stepper]"></ng-content>
      </div>
    }
    @if (options.recap.isAllowed) {
      <div
        [ngClass]="{'active':options.recap.isActive }"
        (click)="clickOnElem(null)"
        fxLayoutAlign="space-evenly center"
        class="step">
        <mat-icon class="number flag"
          svgIcon="flag">
        </mat-icon>
        @if (options.recap.isArrowActive) {
          <mat-icon
            class="arrow"
            [ngClass]="arrowPositionClass"
            svgIcon="arrow_right">
          </mat-icon>
        }
      </div>
    }
  </div>
}